/**
 * プランの経路を組み立てる純粋関数
 *
 * 一覧の地図（プランごとの線）と詳細の地図（1 本の線）で同じ計算を使うため、
 * コンポーネントとは別ファイルに置いてある。
 */

import type { RoutePlanItem } from '@/api/types/route-plan'

export const ROUTE_COLOR = '#F97316'

type Located = { item: RoutePlanItem; position: google.maps.LatLngLiteral }

/** 座標が入っていないスポットは地図に出せないので落とす */
export const toLocated = (items: RoutePlanItem[]): Located[] =>
  items.flatMap((item) =>
    item.latitude === null || item.longitude === null
      ? []
      : [{ item, position: { lat: item.latitude, lng: item.longitude } }],
  )

/** 経路線に使う座標。出発地・到着地を端に足して閉じる */
export const routePath = (
  stops: google.maps.LatLngLiteral[],
  origin: google.maps.LatLngLiteral | null,
  returnToOrigin: boolean,
  destination: google.maps.LatLngLiteral | null,
): google.maps.LatLngLiteral[] => {
  if (!origin) return stops
  if (returnToOrigin) return [origin, ...stops, origin]
  return destination ? [origin, ...stops, destination] : [origin, ...stops]
}

/** 地図を合わせる範囲に使う、スポットの座標だけの一覧 */
export const planPoints = (items: RoutePlanItem[], skippedItems: RoutePlanItem[]): google.maps.LatLngLiteral[] => [
  ...toLocated(items).map((entry) => entry.position),
  ...toLocated(skippedItems).map((entry) => entry.position),
]
